import chooseVisitors from './steps/choose-visitors'
import chooseDate from './steps/choose-date'
import donate from './steps/donate'
import infoModal from './../modules/info-modal'
import productsList from './../modules/products-list'
import spinnerBtn from './../modules/spinner-btn'
import elementary from '../vendor/elementary'

infoModal()
productsList()
spinnerBtn()
elementary()

if (document.querySelector('[data-visitors-selector]') !== null) {
	chooseVisitors()
}

if (document.querySelector('[data-calendar]') !== null) {
	chooseDate()
}

if (document.querySelector('[data-donate]') !== null) {
	donate()
}

// Get step element
const step        = document.querySelector('[data-booking-step]');
const nextStepBtn = step.querySelector('[data-next-step-btn]');

// Listen for validity change event
step.addEventListener('step-validity-change', (e) => {
	
	// Disable/enable next btn as needed
	nextStepBtn.disabled = ((e.detail) ? false : true)
})